export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      {/* <div className="about--section--img">
        <img src="./img/2.png" alt="About Me" />
      </div> */}
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I am currently pursuing a Master's in Computer Science at the
            University of Pune. My formal academic training and professional
            experience have equipped me with skills in HTML, CSS, JavaScript,
            React, Node.js, AJAX, JSON, Express.js, MongoDB, and other related
            technologies. I have completed a MERN stack certification course and
            am currently working as a Software Developer at Bajaj Finserv Direct
            Limited.
          </p>
          <p className="hero--section-description">
            My hands-on experience in developing projects focusing on various
            concepts of Database Management systems and Web development has
            honed my skills as a front-end and back-end developer, providing me
            with valuable software troubleshooting experience. Additionally, I
            am proficient in using Git, GitHub, Netlify, and Render for version
            control and deployment.
          </p>
        </div>
      </div>
    </section>
  );
}
